import { useFocusOnMount, usePreviousFocus } from "@react-md/utils";
/**
 * This is just a simple component that is used with the `Menu` component to
 * handle the initial focus on mount and re-focusing a previous element on
 * unmount.
 * @internal
 */
export function MenuEvents(_a) {
    var menuRef = _a.menuRef, cancelled = _a.cancelled, defaultFocus = _a.defaultFocus;
    usePreviousFocus(cancelled);
    useFocusOnMount(menuRef, defaultFocus, false, true);
    return null;
}
//# sourceMappingURL=MenuEvents.js.map